import { render } from "./ApeConstructorTraitCardRarity.vue?vue&type=template&id=3264285e"
import script from "./ApeConstructorTraitCardRarity.vue?vue&type=script&lang=js"
export * from "./ApeConstructorTraitCardRarity.vue?vue&type=script&lang=js"

import "./ApeConstructorTraitCardRarity.vue?vue&type=style&index=0&id=3264285e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__